
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.914 4.061l-10.55 10.55a2.002 2.002 0 01-2.831 0L1.086 9.166a2.002 2.002 0 012.83-2.831l4.032 4.032 9.135-9.135a2.002 2.002 0 012.831 2.83z","fill":"currentColor"}})])
          )
        }
      }
    